const e=["autoCapitalize","autoComplete","autoCorrect","spellCheck","stripPastedStyles","handleBeforeInput","handlePastedText","handleReturn","tabIndex"];export{e as DRAFT_EDITOR_PROPS};
//# sourceMappingURL=consts.js.map
